import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import {
  ChevronLeft,
  ChevronRight,
  ExternalLink,
} from "lucide-react";

export default function ProjectSlider({ projects }) {
  const [current, setCurrent] = useState(0);
  useEffect(() => {
    if (!projects?.length) return;
  
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % projects.length);
    }, 4000); // Change every 4 seconds
  
    return () => clearInterval(interval);
  }, [projects]);

  const project = projects[current];

  const nextProject = () => {
    setCurrent((prev) => (prev + 1) % projects.length);
  };

  const prevProject = () => {
    setCurrent((prev) =>
      prev === 0 ? projects.length - 1 : prev - 1
    );
  };

  return (
    <div className="mt-2 w-full max-w-[280px]">

      <AnimatePresence mode="wait">

        <motion.div
          key={current}
          initial={{ opacity: 0, x: 30 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -30 }}
          transition={{ duration: 0.3 }}
          className="overflow-hidden rounded-2xl border border-violet-500/20 bg-gradient-to-br from-[#1b1835] to-[#2d2552] shadow-xl"
        >
          {/* Header */}
          {/* <div className="flex items-center justify-between border-b border-white/10 px-4 py-3">
            <span className="rounded-full bg-violet-500/20 px-3 py-1 text-[10px] font-semibold uppercase text-violet-200">
              {project.category}
            </span>

            <div className="flex items-center gap-1 text-pink-400">
              <Sparkles size={15} />
              <span className="text-[10px]">
                {current + 1}/{projects.length}
              </span>
            </div>
          </div> */}

          {/* Image */}
          <div className="overflow-hidden">
            <img
              src={project.image}
              alt={project.title}
              className="h-32 w-full object-cover transition duration-500 hover:scale-105"
            />
          </div>

          {/* Content */}
          <div className="p-4">
            <h3 className="text-[15px] font-bold text-white">
              {project.title}
            </h3>

            <p className="mt-2 text-[12px] leading-5 text-violet-200">
              {project.description}
            </p>

            {/* Visit Button */}
            <a
              href={project.url}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 flex w-full items-center justify-center gap-2 rounded-xl bg-gradient-to-r from-fuchsia-600 to-violet-600 py-2.5 text-sm font-semibold text-white transition hover:scale-[1.02]"
            >
              <ExternalLink size={16} />
              Visit Website
            </a>

            {/* Navigation */}
            <div className="mt-4 flex items-center justify-between">
              <button
                onClick={prevProject}
                className="flex items-center gap-1 rounded-lg border border-white/10 px-3 py-2 text-xs text-white transition hover:bg-white/10"
              >
                <ChevronLeft size={16} />
                Prev
              </button>

              <button
                onClick={nextProject}
                className="flex items-center gap-1 rounded-lg border border-white/10 px-3 py-2 text-xs text-white transition hover:bg-white/10"
              >
                Next
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </motion.div>

      </AnimatePresence>
    </div>
  );
}